module.exports = "https://cdn.betha.cloud/base/g4/design/3.11.9/assets/images/b30-aponta-esquerda.png";